import { render } from "./App.vue?vue&type=template&id=2e3b7ca8"
const script = {}

import "./App.vue?vue&type=style&index=0&id=2e3b7ca8&lang=less"

import exportComponent from "D:\\liang_front_end\\agent-yuyooke\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__